/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {ContinuingMedicalEducation} from './continuing-medical-education.model';
import {UserIdentifiedModelListService} from '../../common/user-identified-model-list.service';

@Injectable()
export class ContinuingMedicalEducationService extends UserIdentifiedModelListService<ContinuingMedicalEducation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'continuingMedicalEducation', ContinuingMedicalEducation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/cme/continuing-medical-education.service.ts